import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import withRouter from 'src/components/withRouter';
import withProfile from 'src/components/withProfile';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';
import i18n from 'src/i18n';

import { Helmet } from 'react-helmet';

import signInViewModel from 'src/components/Header/component/SignIn/viewModel';
import { SuccessToast } from 'src/libs/toast';

import messageIcon from 'src/assets/courseDetail/messageIcon.svg';
import Checked from 'src/assets/courseDetail/checked.png';

import PurchaseAlert from 'src/components/PurchaseAlert';

import loading from 'src/services/loading';
import MainCard from './components/MainCard';
import SectionTabs from './components/SectionTabs';
import CoursePageViewModel from './viewModel';


import styles from './styles.module.scss';

@observer
class CoursePage extends React.Component {
  constructor(props) {
    super(props);

    this.viewModel = new CoursePageViewModel(this.props.router);
  }

  componentDidMount() {
    this.viewModel.didMount(this.props.router);
  }

  componentDidUpdate() {
    this.viewModel.didUpdate(this.props.router);
  }

  render() {
    const { profile } = this.props;
    return (
      <>
        <Helmet>
          <title>{`${this.viewModel.mainCardVm.name ?? '課程'} | sandshour 散時間 - 影音內容訂閱平台`}</title>
        </Helmet>
        <div className={clsx('course-detail', styles.main, styles.main_layout, 'main-flex-subscriber')}>
          <MainCard
            viewModel={this.viewModel.mainCardVm}
            isSmall={this.viewModel.isSmall}
            ratingCount={this.viewModel.infoSecVm.totalRatingCount}
            bread={this.viewModel.bread}
          />
          <SectionTabs viewModel={this.viewModel.sectionTabsVm} isSmall={this.viewModel.isSmall} />
          {
            this.viewModel.sectionTabsVm.nowSection === 'comment' && (
              <div className={clsx(styles.commentInputContainer, styles.commentInputContainer_layout)}>
                <div className={clsx(styles.commentInputContent, styles.commentInputContent_layout)}>
                  <div className={clsx(styles.innerFlex, styles.innerFlex_layout)}>
                    <div className={clsx(styles.innerFlex_item)}>
                      <div
                        className={clsx(styles.inputBtn, styles.inputBtn_layout)}
                        onClick={
                          profile
                            ? () => this.viewModel.commentSecVm.commentModalVm.onOpen(this.viewModel.commentSecVm.modalData)
                            : () => {
                              SuccessToast(i18n.t('common_login_unlock'));
                              setTimeout(() => {
                                signInViewModel.handleOpen();
                              }, 500);
                            }

                        }
                      >
                        <div className={clsx(styles.btnFlex, styles.btnFlex_layout)}>
                          <div
                            style={{ '--src': `url(${messageIcon})` }}
                            className={clsx(styles.messageIcon, styles.messageIcon_layout)}
                          />
                          <div className={clsx(styles.btnFlex_item)}>
                            <h5 className={clsx(styles.placeholder)}>
                              {i18n.t('course_tab_comments_input')}
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={clsx(styles.innerFlex_spacer)} />
                    <div className={clsx(styles.innerFlex_item1)}>
                      <div
                        className={clsx(styles.myComment)}
                        onClick={
                          profile
                            ? this.viewModel.commentSecVm.onMyCommentClick
                            : () => {
                              SuccessToast(i18n.t('common_login_unlock'));
                              setTimeout(() => {
                                signInViewModel.handleOpen();
                              }, 500);
                            }
                        }
                      >
                        {
                          this.viewModel.commentSecVm.showMyComments
                            ? (
                              <img
                                src={Checked}
                                alt="checked"
                                className={clsx(styles.selectBox_layout)}
                              />
                            )
                            : (
                              <div className={clsx(styles.selectBox, styles.selectBox_layout)} />
                            )
                        }

                        <div className={clsx(styles.myComment_spacer)} />
                        <h5 className={clsx(styles.myCommentText, styles.myCommentText_layout)}>
                          {i18n.t('course_tab_comments_checkbox')}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          <div className={clsx(styles.tabContent, styles.tabContent_layout)}>
            <div className={clsx(styles.tabContainer, styles.tabContainer_layout)}>
              <div className={clsx(styles.tabBox, styles.tabBox_layout)}>
                <div className={clsx(styles.block5, styles.block5_layout)}>
                  <Outlet context={this.viewModel.secViewModels} />
                </div>
              </div>
            </div>
          </div>
          <div className={clsx(styles.bottomBtnContent, styles.bottomBtnContent_layout)}>
            <div className={clsx(styles.bottomBtns, styles.bottomBtns_layout)}>
              <div className={clsx(styles.btnContainer, styles.btnContainer_layout)}>
                {
                  this.viewModel.mainCardVm.isOwned || (this.viewModel.mainCardVm.saleType !== 'Single' && (!!profile && profile?.group === 'Subscriber'))
                    ? (
                      <Link
                        to={`/course/${this.viewModel.mainCardVm.id}/chapter`}
                        onClick={this.viewModel.mainCardVm.onStartLearnClick}
                        className={clsx(styles.purchaseBtnContainer_item)}
                      >
                        <div className={clsx(styles.subscribeBtn, styles.subscribeBtn_layout)}>
                          <h3 className={clsx(styles.subtitle1, styles.subtitle1_layout)}>
                            {i18n.t('course_start_learn')}
                          </h3>
                        </div>
                      </Link>
                    )
                    : (
                      <>
                        {
                          this.viewModel.mainCardVm.saleType !== 'Single'
                            ? (
                              <>
                                <div
                                  className={clsx(styles.purchaseBtnContainer_item, styles.borderTypeBtn)}
                                  onClick={this.viewModel.mainCardVm.purchaseModalVm.handlerOpenAlert}
                                >
                                  <h5 className={clsx(styles.purchaseBtn_box, styles.purchaseBtn_box_layout)}>
                                    <pre className={clsx(styles.purchaseBtn)}>購買</pre>
                                  </h5>
                                </div>
                                <div className={clsx(styles.purchaseBtnContainer_spacer)} />
                                <Link
                                  to="/subscription"
                                  className={clsx(styles.purchaseBtnContainer_item)}
                                >
                                  <div className={clsx(styles.subscribeBtn, styles.subscribeBtn_layout)}>
                                    <h3 className={clsx(styles.subtitle1, styles.subtitle1_layout)}>
                                      {(!!profile && profile.group === 'ExpiredSubscriber') ? i18n.t('course_sub') : i18n.t('course_free')}
                                    </h3>
                                  </div>
                                </Link>
                              </>
                            )
                            : (
                              <div
                                className={clsx(styles.purchaseBtnContainer_item)}
                                onClick={this.viewModel.mainCardVm.purchaseModalVm.handlerOpenAlert}
                              >
                                <div className={clsx(styles.subscribeBtn, styles.subscribeBtn_layout)}>
                                  <h3 className={clsx(styles.subtitle1, styles.subtitle1_layout)}>
                                    {i18n.t('course_purchase')}
                                  </h3>
                                </div>
                              </div>
                            )
                        }
                      </>
                    )
                }
              </div>
            </div>
          </div>

          <PurchaseAlert viewModel={this.viewModel.purchaseAlert} />
        </div>
      </>
    );
  }
}

CoursePage.propTypes = {
  router: PropTypes.object,
  profile: PropTypes.object
};

CoursePage.defaultProps = {
  router: {},
  profile: {}
};

export default withProfile(withRouter(CoursePage), false);
